/* Môdern Studio — shared product exclusion rules (Oct 1, 2026)
 *
 * One place that decides which catalog products the Môdern Studio tools may
 * show. Every tool that pulls products from the catalog asks this file.
 *
 *   1. Tag: any product tagged `studio-exclude` is hidden from every tool.
 *      This is the manual switch — add the tag in Shopify admin to hide a
 *      product, remove it to bring the product back.
 *   2. NON_HOME types: things that are not home products at all (Môdern
 *      Guides, books, gift cards, memberships, electronics). Hidden from every
 *      tool.
 *   3. NON_DECOR types: appliances, fitness, cleaning supplies and consumables.
 *      Hidden from the design tools (Space Planner, Mood Board) but still
 *      allowed in shopping tools (Furniture Finder, Gift Finder), where an air
 *      fryer is a perfectly good answer.
 *
 * Usage: MSGStudioExclude.isExcluded(product, 'design' | 'shop')
 * Reads product_type / productType / type and tags (array or comma string),
 * so it works with /products.json, predictive search and Storefront API
 * shapes alike. If this file fails to load, tools treat nothing as excluded.
 */
(function () {
  'use strict';

  var TAG = 'studio-exclude';

  var NON_HOME = [
    'digital guide', 'digital guide bundle', 'digital downloads',
    'books', 'ebooks', 'audiobooks',
    'memberships', 'gift cards', 'store operations',
    'laptops', 'speakers & audio', 'portable power stations'
  ];

  var NON_DECOR = [
    // kitchen & home appliances (electric kettles are left out on purpose:
    // the Mood Board's kitchen board has a Tea Kettle slot)
    'air fryers', 'blenders & mixers', 'bread makers', 'coffee & espresso machines',
    'deep fryers', 'food dehydrators', 'ice cream makers', 'ice makers',
    'indoor grills & griddles', 'juicers', 'pasta makers', 'pressure cookers', 'slow cookers',
    'sous vide', 'specialty kitchen appliances', 'tea makers', 'toasters & toaster ovens',
    'yogurt makers', 'toaster', 'food_mixer', 'refrigerators', 'mini fridges', 'chest freezers', 'beverage & wine coolers',
    'vacuums', 'robot vacuums & mops', 'carpet cleaners', 'air purifiers', 'fans',
    'water filtration', 'lawn mowers', 'string trimmers',
    // fitness
    'treadmills', 'exercise bikes', 'home gym systems', 'free weights', 'weight benches',
    'weight accessories', 'resistance bands', 'jump ropes', 'exercise balls', 'yoga mats',
    'step platforms', 'body scales',
    // cleaning & consumables
    'cleaning supplies', 'cleaning tools', 'cleaning cloths', 'cleaning gloves',
    'bathroom cleaners', 'disinfectants', 'dishwashing', 'laundry detergent', 'laundry care',
    'paper goods', 'tea & infusions', 'air mattresses', 'prefab & tiny homes'
  ];

  function typeOf(p) {
    return String((p && (p.product_type || p.productType || p.type)) || '').toLowerCase().trim();
  }

  function tagsOf(p) {
    var t = p && p.tags;
    if (!t) return [];
    if (typeof t === 'string') t = t.split(',');
    if (!Array.isArray(t)) return [];
    return t.map(function (x) { return String(x).toLowerCase().trim(); });
  }

  function isExcluded(p, scope) {
    if (!p) return false;
    if (tagsOf(p).indexOf(TAG) !== -1) return true;
    var type = typeOf(p);
    if (!type) return false;
    if (NON_HOME.indexOf(type) !== -1) return true;
    if (scope === 'design' && NON_DECOR.indexOf(type) !== -1) return true;
    return false;
  }

  window.MSGStudioExclude = {
    TAG: TAG, NON_HOME: NON_HOME, NON_DECOR: NON_DECOR,
    isExcluded: isExcluded
  };
})();